import { client } from "shared/utils/rest-client";

const API_URL = process.env.REACT_APP_BACKEND_URL;

function center(projectId: string) {
  return client.post(`${API_URL}/optimizer/center`, {
    project_id: projectId,
  });
}

export const optimizerService = {
  center,
};
